export var productsGridBreakpoints = [{
  screen: 'miniPhone',
  columns: 1
}, {
  screen: 'phone',
  columns: 1
}, {
  screen: 'phablet',
  columns: 3
}, {
  screen: 'tablet',
  columns: 4
}, {
  screen: 'miniDesktop',
  columns: 4
}, {
  screen: 'desktop',
  columns: 4
}, {
  screen: 'bigScreen',
  columns: 4
}];